import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface RequestQuery {
    category: string;
}
interface RequestBody {
    list_no: number[];
}
type DeleteRequest = RequestQuery & RequestBody;

interface DeleteResponse {
    statusCode: number;
    message: string;
    data: null;
}

export const useDeleteConsoleSupplies = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const url = enum_api_uri.delete_console_supplies.replace(":category", body.category);
            const res = await axiosInstance.delete(url, { data: { list_no: body.list_no } });
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleSupplies"] });
            onSuccessCallback?.();
        },
    });
};
